<template>
  <div id="app">
    <router-view>

    </router-view>
  </div>
</template>

<script>

  export default {
    name: 'App',
    data () {
      return {
      }
    },
    components:{
    },
    watch:{
    },
    mounted:function () {
    },
    methods:{
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue